<div id="QRCodeManual" class="ya-typography">
  <ya-subheader [hasContent]="true" [useNavigateData]="true">

  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset">
    <div class="ya-qrcode-content">
      <div class="inline-icon qrcodeInput_icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch-voll"></div>
      <div class="qrcode-description">
        <h2 langkey="phQRCode_Manual_Page_Title"></h2>
        <p langkey="phQRCode_Manual_Page_Description"></p>
      </div>
      <form #qrcodeForm="ngForm" class="ya-form-wrapper" novalidate>
        <div class="ya-form-control-container">
          <ya-customInput #input name="qrcodeText" inputType="text" (keydown.enter)="input.blur()"
            [(ngModel)]="tablecode" (input)="onInput()" formTouchedOnClick inputPlaceholder="phQRCode_PlaceHolder"
            required>
            <ng-container *ngIf="qrcodeForm.form.controls['qrcodeText']">
              <ya-errorvalidation
                [controlValidation]="qrcodeForm.form.controls['qrcodeText'].invalid && qrcodeForm.form.controls['qrcodeText'].touched"
                errorMessage="phQRCode_Manual_Validate"></ya-errorvalidation>
            </ng-container>
          </ya-customInput>
        </div>
        <div class="ya-webshop-button-container">
          <ng-container *ngIf="qrcodeForm.valid && qrcodeForm.touched; then activeButton else deactiveButton">
          </ng-container>
          <ng-template #activeButton>
            <button type="button" mat-flat-button (click)="submitQRCodeData()">
              <span langkey="phQRCode_Manual_Page_Button"></span>
            </button>
          </ng-template>
          <ng-template #deactiveButton>
            <span (click)="showErrorValidation(qrcodeForm)">
              <button type="button" mat-flat-button disabled>
                <span langkey="phQRCode_Manual_Page_Button"></span>
              </button>
            </span>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>